<template>
    <Transition
        name="modal"
        :duration="500"
    >
        <div
            v-if="opened"
            class="Modal flex row-center"
        >
            <div
                class="Dialog flex-1"
            >
                <div
                    v-if="$slots.header || title"
                    class="Header"
                >
                    <WText
                        v-if="title"
                        tag="span"
                        class="mb-0"
                        :size="22"
                    >
                        {{ title }}
                    </WText>
                    <slot
                        name="header"
                    />
                    <WIcon
                        v-if="closeBtn && dissmisable"
                        icon="close"
                        class="Close"
                        @click="$emit('close')"
                    />
                </div>
                <div
                    v-if="$slots.body"
                    class="Body"
                >
                    <slot name="body" />
                </div>
                <div
                    v-if="$slots.footer"
                    class="Footer"
                >
                    <slot name="footer" />
                </div>
            </div>
            <div
                class="Backdrop"
                @click="dissmisable ? $emit('close') : null"
            />
        </div>
    </Transition>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Modal',
    props: {
        opened: VueTypes.bool.def(false),
        title: VueTypes.string,
        closeBtn: VueTypes.bool.def(true),
        dissmisable: VueTypes.bool.def(true),
    },
    watch: {
        opened (opened) {
            if (opened) document.body.classList.add('no-scroll')
            else document.body.classList.remove('no-scroll')
        },
    },
}
</script>

<style scoped lang="scss">
.Modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 0;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
    z-index: 9996;
}

.Backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9997;
    background-color: rgba($black, 0.5);
}
.Dialog {
    position: relative;
    width: auto;
    max-width: 95%;
    max-height: 100%;
    margin: 0px auto;
    border-radius: $border-radius;
    // border-top: 5px solid $secondary;
    background: $modal-bg;
    box-shadow: 0 2px 5px 0 rgba($black, 0.2);
    z-index: 9998;
    overflow: auto;

    @media screen and (min-width: $md) {
        max-width: 600px;
        margin: 50px auto;
    }
}
.Close {
    position: absolute;
    top: 25px;
    right: 25px;
    color: $modal-close-color;
    opacity: .5;
    font-size: 24px;
    cursor: pointer;
}
.Header {
    position: relative;
    display: flex;
    align-items: center;
    padding: 25px 25px 0 25px;
}
.Body {
    padding: 25px;
}
.Footer {
    padding: 25px;
}

.modal-enter-active,
.modal-leave-active {
    .Dialog {
        transition-duration: 0.5s;
        transition-property: opacity, transform;
        transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    }
    .Backdrop {
        transition: opacity 0.5s ease-in-out;
    }
}

.modal-enter,
.modal-leave-to {
    .Backdrop {
        opacity: 0;
    }
    .Dialog {
        opacity: 0;
        transform: translateY(-50px);
    }
}
</style>
